import { useMutation, useQuery } from "@tanstack/react-query";
import { IProjectPartnerAllocation } from "../../interfaces/IProjectPartnerAllocation";
import { customFetcher } from "../useFetch";

export const useUpdateAllocations = () => {
    const { mutateAsync: updateAllocations, isPending: isPendingUpdateAllocation } = useMutation({
        mutationFn: ({
            allocationObject,
            projectId,
        }: {
            allocationObject: IProjectPartnerAllocation[];
            projectId: number;
        }) =>
            customFetcher({
                endpoint: `/project/${projectId}/partnerallocation`,
                method: "PUT",
                body: allocationObject,
            }),
    });

    return {
        updateAllocations,
        isPendingUpdateAllocation,
    };
};

export const useCreatePartnerAllocations = () => {
    const { mutateAsync: createPartnerAllocations, isPending: isPendingPartnerAllocations } = useMutation({
        mutationFn: ({
            partnerAllocations,
            idProject,
        }: {
            partnerAllocations: IProjectPartnerAllocation[];
            idProject: number;
        }) =>
            customFetcher({
                endpoint: `/project/${idProject}/partnerallocation`,
                method: "POST",
                body: partnerAllocations,
            }),
    });

    return {
        createPartnerAllocations,
        isPendingPartnerAllocations,
    };
};

export const useGetAllocations = (idProject: number) => {
    const {
        data: allocationArray,
        isLoading: isLoadingAllocationArray,
        refetch: refetchAllocationArray,
    } = useQuery<IProjectPartnerAllocation[]>({
        queryKey: ["project/partnerallocation/", idProject],
        queryFn: () => customFetcher({ endpoint: `/project/${idProject}/partnerallocation` }),
    });
    return { allocationArray, isLoadingAllocationArray, refetchAllocationArray };
};
